import { useState } from 'react'
import { PostcodeSearch } from './components/postcode-search/postcode-search'
import { useGetSites } from './find-a-site.hook'
import { Heading, Text } from '@cinch-labs/design-system'
import styles from './find-a-site.module.css'
import { LoadingSpinner } from '@cinch-nx/shared-ui'
import {
  Address,
  AttributeFilters,
  Coordinates,
  Site,
} from '@cinch-labs/sites-sdk'
import { SiteResults } from './components/site-results/site-results'

export interface FindASiteContentProps {
  title?: string
  subtitle?: string
  searchButtonText: string
  siteCardButtonText: string
  showMoreButtonText: string
}

export interface ListedSite {
  siteId: string
  siteName: string
  address: Address
  coordinates: Coordinates
  distance: number
  site: Site
}

export interface FindASiteProps {
  onSiteCardClick: (site: Site) => void
  siteQueryFilters: AttributeFilters
  content: FindASiteContentProps
}

export const FindASite: React.FC<FindASiteProps> = ({
  onSiteCardClick,
  siteQueryFilters,
  content,
}) => {
  const [postcode, setPostcode] = useState<string | undefined>()
  const [mobileSelectedSite, setMobileSelectedSite] = useState<
    ListedSite | undefined
  >()

  const { data, isLoading, error } = useGetSites({
    postcode,
    filters: siteQueryFilters,
    setMobileSelectedSite,
  })

  return (
    <div className={styles.container}>
      {content.title && (
        <Heading element="h3" className={styles.heading}>
          {content.title}
        </Heading>
      )}
      {content.subtitle && <Text>{content.subtitle}</Text>}
      <PostcodeSearch
        setPostcode={setPostcode}
        errorText={error ? 'An error occurred' : undefined}
        buttonText={content.searchButtonText}
      />
      {isLoading && <LoadingSpinner size={75} />}
      {data && (
        <SiteResults
          sites={data.sites}
          content={content}
          userLocation={{
            postcode: data.validPostcode,
            coordinates: data.coordinates,
          }}
          onSiteCardClick={onSiteCardClick}
          mobileSelectedSite={mobileSelectedSite}
        />
      )}
    </div>
  )
}
